<template>
  <div class="new-campaign-initial-data pt-0">
    <div id="header-div" class="header-div">
      <v-row class="py-2">
        <v-col cols="12" class="py-0 px-0" :class="display === 'xs' || display === 'sm' ? 'text-center' : ''">
          <div v-if="display === 'xs' || display === 'sm'" class="d-flex flex-column align-center">
            <h3 class="header-main py-1">
              <span class="bold-title">{{$t('NewCampaignInitialData.serviceOnboardingTitle')}}</span>
              <span>{{$store.getters.userOrganization.name}}</span>
            </h3>
            <div class="save-status-indicator mt-2">
              <div v-if="saveStatus === 'saving'" class="d-flex align-center">
                <v-icon class="save-icon saving mr-1" >mdi-refresh</v-icon>
                <span class="save-text">{{$t('NewCampaignInitialData.saving')}}</span>
              </div>
              <div v-else-if="saveStatus === 'saved'" class="d-flex align-center">
                <v-icon class="save-icon saved mr-1">mdi-cloud-check-outline</v-icon>
                <span class="save-text">{{$t('NewCampaignInitialData.changesSaved')}}</span>
              </div>
            </div>
          </div>
          <div v-else class="d-flex align-center justify-space-between">
            <h3 class="header-main py-3">
              <span class="bold-title">{{$t('NewCampaignInitialData.serviceOnboardingTitle')}}</span>
              <span>{{$store.getters.userOrganization.name}}</span>
            </h3>
            <div class="save-status-indicator">
              <div v-if="saveStatus === 'saving'" class="d-flex align-center">
                <v-icon class="save-icon saving mr-1" >mdi-refresh</v-icon>
                <span class="save-text">{{$t('NewCampaignInitialData.saving')}}</span>
              </div>
              <div v-else-if="saveStatus === 'saved'" class="d-flex align-center">
                <v-icon class="save-icon saved mr-1">mdi-cloud-check-outline</v-icon>
                <span class="save-text">{{$t('NewCampaignInitialData.changesSaved')}}</span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-divider />
    </div>
    <div v-if="campaign" class="new-campaign-content">
      <NewCampaignIntroduction v-show="currentStep === CAMPAIGN_STEPS.INTRODUCTION" :nextStep="nextStep" :products="products" :campaignId="campaignId" />
      <NewCampaignTermsAndConditions v-show="currentStep === CAMPAIGN_STEPS.T_AND_C" :nextStep="nextStep" :campaignId="campaignId" :campaign="campaign" />
      <NewCampaignDevicesAndServices v-show="currentStep === CAMPAIGN_STEPS.EQUIPMENTS" :nextStep="nextStep" :previousStep="previousStep" :products="products" :campaignId="campaignId" :comesFromAnotherRoute="comesFromAnotherRoute" :comesFromAnotherRouteData="comesFromAnotherRouteData" :saveMethods="{ setSaving: setSavingStatus, setSaved: setSavedStatus, performSave: performSave }"/>
      <NewCampaignFinish v-show="currentStep === CAMPAIGN_STEPS.FINISH" :nextStep="nextStep" :campaignId="campaignId"/>
    </div>
  </div>
</template>

<script>
import NewCampaignIntroduction from '@/components/Campaigns/NewCampaignIntroduction.vue'
import NewCampaignTermsAndConditions from '@/components/Campaigns/NewCampaignTermsAndConditions.vue'
import NewCampaignDevicesAndServices from '@/components/Campaigns/NewCampaignDevicesAndServices.vue'
import NewCampaignFinish from '@/components/Campaigns/NewCampaignFinish.vue'
import _findIndex from 'lodash/findIndex'
import _last from 'lodash/last'
import _get from 'lodash/get'
import _uniq from 'lodash/uniq'
import _flatten from 'lodash/flatten'
import { CAMPAIGN_STEPS, FIRESTORE_CAMPAIGN_PRE_DATA_STEPS, PRODUCT_TYPES } from '../../constants/const'
import { getCampaignById } from '@/lib/crudOperations/read'
import { firestore, firestoreConstructors } from '@/plugins/firebase'
import { getLatestClonedFields, parseCrop } from '@/lib/helpers'

export default {
  name: 'NewCampaignInitialData',
  data () {
    const campaignId = _get(this.$route, 'params.campaignId') || _get(this.$route, 'params.comesFromAnotherRouteData.campaignId') || ''
    return {
      campaignId,
      steps: [
        CAMPAIGN_STEPS.INTRODUCTION,
        CAMPAIGN_STEPS.T_AND_C,
        CAMPAIGN_STEPS.EQUIPMENTS,
        CAMPAIGN_STEPS.FINISH
      ],
      currentStep: null,
      CAMPAIGN_STEPS,
      comesFromAnotherRoute: this.$route.params.comesFromAnotherRoute || false,
      comesFromAnotherRouteData: this.$route.params.comesFromAnotherRouteData || {},
      campaign: this.$store.getters.getCampaign(campaignId),
      saveStatus: null,
      saveTimeout: null
    }
  },
  components: {
    NewCampaignIntroduction,
    NewCampaignTermsAndConditions,
    NewCampaignDevicesAndServices,
    NewCampaignFinish
  },
  mounted () {
    if (!this.campaign) {
      this.$router.push('/organizationHome')
      return
    }

    // Initialize currentStep after computed properties are available
    this.currentStep = this.getCurrentStep()
  },
  computed: {
    display () {
      return this.$vuetify.breakpoint.name
    },
    products () {
      // Handle case when campaign is undefined
      if (!this.campaign || !this.campaign.dealItems) {
        return []
      }

      return this.campaign.dealItems.map(product => {
        const productDetail = this.$store.getters.globalConstants.products.find(p => p.id === product.id)
        if (productDetail.type === PRODUCT_TYPES.MONITORING) {
          return {
            quantity: product.quantity,
            deviceType: productDetail.deviceType,
            durationMonths: productDetail.durationMonths,
            serviceName: productDetail.serviceName,
            id: product.id,
            devices: this.campaign.preDataProductsDetail ? this.campaign.preDataProductsDetail.find(p => p.id === product.id).devices : [],
            type: productDetail.type
          }
        } else if (productDetail.type === PRODUCT_TYPES.EXTENSION) {
          return {
            durationMonths: productDetail.durationMonths,
            id: product.id,
            type: productDetail.type,
            quantity: product.quantity,
            extensions: this.campaign.preDataProductsDetail && this.campaign.preDataProductsDetail.find(p => p.id === product.id) && this.campaign.preDataProductsDetail.find(p => p.id === product.id).extensions || []
          }
        }
      })
    },
  },
  methods: {
    async nextStep () {
      const isLastStep = this.currentStep === _last(this.steps)
      if (isLastStep) {
        const db = await firestore
        // Update new campaign data in store
        const campaign = await getCampaignById(this.campaignId)

        // Convert device id to device object
        if (campaign.devices) {
          campaign.devices = campaign.devices.map(device => {
            const deviceData = this.$store.getters.organizationDevices.find(d => d.id === device)
            return deviceData
          })
        }

        // Convert field id to field object
        if (campaign.fields) {
          // First, reload organizationFields to get the latest data including newly created fields
          const organizationId = this.$store.getters.userOrganization.id
          let organizationFields = await this.getOrganizationFields(organizationId, db)
          organizationFields = getLatestClonedFields(organizationFields)
          this.$store.commit('setOrganizationFields', organizationFields)

          campaign.fields = campaign.fields.map(field => {
            const fieldData = this.$store.getters.organizationFields.find(f => f.id === field)
            return fieldData
          })

          // Get crops for the fields
          let fieldsCrops = await this.getCropsForFields(organizationFields, db)
          this.$store.commit('setCrops', [
            ...this.$store.getters.crops,
            ...fieldsCrops.filter(crop => !this.$store.getters.crops.some(c => c.id === crop.id))
          ])
        }

        // Convert user id to user object
        if (campaign.users) {
          const usersIds = [...campaign.users] // Create a copy to avoid modifying the original
          const usersData = []
          const usersQueries = []

          while (usersIds.length) {
            const usersIdsBatch = usersIds.splice(0, 10)
            const usersQuery = db.collection('app/v1/users').where(firestoreConstructors.FieldPath.documentId(), 'in', usersIdsBatch).get()
            usersQueries.push(usersQuery)
          }

          const usersQueriesSnapshot = await Promise.all(usersQueries)
          const usersDocs = usersQueriesSnapshot.reduce((usersAcc, snapshot) => {
            snapshot.forEach(doc => { usersAcc.push(doc) })
            return usersAcc
          }, [])

          for (const user of usersDocs) {
            const userCampaign = await db.collection('app/v1/users').doc(user.id).collection('campaigns').doc(this.campaignId).get()
            const userCampaignData = userCampaign.data()
            const uData = user.data()
            let role = ''
            if (uData.isAdmin) {
              role = 'admin'
            } else if (userCampaignData.roles.owner) {
              role = 'owner'
            } else if (userCampaignData.roles.manager) {
              role = 'manager'
            } else if (userCampaignData.roles.fieldman) {
              role = 'fieldman'
            } else if (userCampaignData.roles.farmhand) {
              role = 'farmhand'
            }
            userCampaignData.devices = userCampaignData.devices ? userCampaignData.devices.map(device => device.id) : []
            usersData.push({
              id: user.id,
              name: uData.name,
              lastName: uData.lastName || '',
              email: uData.email,
              phone: uData.phone,
              reports: userCampaignData.reports,
              devices: userCampaignData.devices,
              role,
              editDataPermission: userCampaignData.editDataPermission,
              editCampaignDataPermission: userCampaignData.editCampaignDataPermission,
              photoUrl: uData.photoUrl,
              channels: uData.channels,
              settings: uData.settings,
              lastUpdatedDate: uData.lastUpdatedDate || ''
            })
          }

          campaign.users = usersData
        }

        this.$store.commit('updateCampaign', {
          campaignId: this.campaignId,
          campaignData: campaign
        })

        // Update availableCampaigns
        const availableCampaigns = this.$store.getters.availableCampaigns
        const campaignIndex = availableCampaigns.findIndex(c => c.id === this.campaignId)
        if (campaignIndex !== -1) {
          availableCampaigns[campaignIndex] = campaign
        } else {
          availableCampaigns.push(campaign)
        }
        this.$store.commit('setAvailableCampaigns', availableCampaigns)
        // Set new campaign as active campaign
        this.$store.commit('setActiveCampaign', this.campaignId)

        // Update data in store
        if (this.$store.getters.activeCampaign === this.campaignId) {
          this.$store.commit('setDevices', campaign.devices)
          this.$store.commit('setFields', campaign.fields)
          this.$store.commit('setUsers', campaign.users)
        }


        return this.$router.push('/organizationHome')
      }
      const nextStepIndex = _findIndex(this.steps, step => step === this.currentStep) + 1
      this.currentStep = this.steps[nextStepIndex]
    },
    previousStep () {
      this.currentStep = this.steps[this.steps.indexOf(this.currentStep) - 1]
    },
    getLastState () {
      const { preDataSteps } = this.campaign
      const steps = [
        { key: FIRESTORE_CAMPAIGN_PRE_DATA_STEPS.INTRODUCTION, returnValue: CAMPAIGN_STEPS.INTRODUCTION },
        { key: FIRESTORE_CAMPAIGN_PRE_DATA_STEPS.T_AND_C, returnValue: CAMPAIGN_STEPS.T_AND_C },
        { key: FIRESTORE_CAMPAIGN_PRE_DATA_STEPS.DEVICES, returnValue: CAMPAIGN_STEPS.EQUIPMENTS },
        { key: FIRESTORE_CAMPAIGN_PRE_DATA_STEPS.FINISH, returnValue: CAMPAIGN_STEPS.FINISH }
      ]

      // Find the first incomplete step
      for (const step of steps) {
        if (!preDataSteps[step.key]) {
          return step.returnValue
        }
      }

      // All steps are complete
      return this.$router.push('/organizationHome')
    },
    getCurrentStep () {
      return this.$route.params.step || _get(this.$route, 'params.comesFromAnotherRouteData.step') || this.getLastState()
    },
    async getOrganizationFields (organizationId, db) {
      const orgFieldsList = await db.collection('app/v1/fields').where('organization', '==', db.collection('app/v1/organizations').doc(organizationId)).get()
      const fields = orgFieldsList.docs.map(field => this.parseField(field.id, field.data()))
      return fields
    },
    async getCropsForFields (fields, db) {
      const cropsIds = _uniq(_flatten(fields.map(field => field.crops)))
      const cropsQueries = []
      let cropsData = []

      while (cropsIds.length) {
        const cropsIdsBatch = cropsIds.splice(0, 10)
        const cropsQuery = db.collection('app/v1/crops').where(firestoreConstructors.FieldPath.documentId(), 'in', cropsIdsBatch).get()
        cropsQueries.push(cropsQuery)
      }

      const cropsQueriesSnapshot = await Promise.all(cropsQueries)
      cropsData = cropsQueriesSnapshot.reduce((cropsAcc, snapshot) => {
        snapshot.forEach(doc => { cropsAcc.push(parseCrop(doc.id, doc.data())) })
        return cropsAcc
      }, [])

      return cropsData
    },
    parseField (fieldId, fieldData) {
      return {
        id: fieldId,
        name: fieldData.name,
        contact: fieldData.contact && fieldData.contact.id,
        auxContact: fieldData.auxContact && fieldData.auxContact.id,
        organization: fieldData.organization && fieldData.organization.id,
        gates: fieldData.gates ? fieldData.gates.map(gate => ({
          latitude: gate.latitude,
          longitude: gate.longitude
        })) : [],
        crops: fieldData.crops ? fieldData.crops.map(crop => crop.id) : []
      }
    },
    setSavingStatus () {
      this.saveStatus = 'saving'
      if (this.saveTimeout) {
        clearTimeout(this.saveTimeout)
      }
    },
    setSavedStatus () {
      this.saveStatus = 'saved'
      if (this.saveTimeout) {
        clearTimeout(this.saveTimeout)
      }
    },
    async performSave (saveOperation) {
      this.setSavingStatus()
      try {
        const [saveResult] = await Promise.all([
          saveOperation(),
          new Promise(resolve => setTimeout(resolve, 1000))
        ])
        this.setSavedStatus()
        return saveResult
      } catch (error) {
        console.error('Save operation failed:', error)
        this.saveStatus = null
        throw error
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// NewCampaignInitialData.vue?6e4ac0be